import { useMutation } from '@apollo/client';
import { REQUEST_PASSWORD_RESET } from '../../apollo/mutations/user';
import extractErrorMessage from '../../utils/extractErrorMessage';

const useRequestPasswordReset = () => {
  const [requestPasswordResetMutation, { loading }] = useMutation(REQUEST_PASSWORD_RESET);

  const requestPasswordReset = async (variables) => {
    try {
      const { data } = await requestPasswordResetMutation({ variables });

      if (!data?.requestPasswordReset) {
        throw new Error('Password reset request failed.');
      }

      return data.requestPasswordReset;
    } catch (error) {
      throw new Error(extractErrorMessage(error));
    }
  };

  return { requestPasswordReset, loading };
};

export default useRequestPasswordReset;